'use client';

import React from 'react';
import type { DynamicGreeting as PayloadDynamicGreeting } from '../../graphql/generated/schema';

export const DynamicGreeting: React.FC<PayloadDynamicGreeting> = () => (
  <React.Fragment>
    {(() => {
      switch (true) {
        case new Date().getHours() < 12:
          return 'Good Morning';
        case new Date().getHours() < 18:
          return 'Good Afternoon';
        default:
          return 'Good Evening';
      }
    })()}
  </React.Fragment>
);
